'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const table_types = require('../table.types.js');
const tableCell = require('../TableCell/table-cell.js');

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getCells = function getCells(rowColumns, props) {
  var type = props.type,
      rowIndex = props.rowIndex,
      data = props.data,
      customCells = props.customCells,
      highlightedCells = props.highlightedCells,
      highlightHead = props.highlightHead,
      dark = props.dark,
      firstRow = props.firstRow,
      lastRow = props.lastRow,
      headerHandlers = props.headerHandlers,
      columnsState = props.columnsState,
      columnSortIndex = props.columnSortIndex,
      highlightSortedColumn = props.highlightSortedColumn,
      highlightColor = props.highlightColor;
  var columns = [];
  var foundFirstGroupStart = false;
  rowColumns.forEach(function (column, i) {
    var columnState = columnsState && columnsState["col-".concat(i)] || {};
    var content = column.content,
        dataField = column.dataField,
        fixedWidth = column.fixedWidth,
        pinned = column.pinned,
        colgroupStart = column.colgroupStart,
        colgroupEnd = column.colgroupEnd,
        placeholder = column.placeholder,
        alignment = column.alignment,
        colgroupSpan = column.colgroupSpan,
        highlighted = column.highlighted;
    var sortable = columnState.sortable,
        sortState = columnState.sortState;
    var cellProps = {
      cellType: type || table_types.CellTypes.BODY,
      content: type === table_types.CellTypes.SUPER_HEADER || type === table_types.CellTypes.HEADER ? content : data[dataField],
      handlers: type === table_types.CellTypes.HEADER ? headerHandlers : undefined,
      rowIndex: typeof rowIndex !== 'undefined' ? rowIndex : 0,
      columnIndex: i,
      fixedWidth: fixedWidth,
      firstColPinned: i === 0 && pinned,
      lastColPinned: i === rowColumns.length - 1 && pinned,
      colgroupEnd: colgroupEnd,
      colgroupStart: colgroupStart,
      placeholder: placeholder,
      colgroupSpan: colgroupSpan,
      tableIndex: props.tableIndex,
      alignment: alignment,
      lastColumn: i === rowColumns.length - 1,
      columnHighlighted: highlighted,
      highlightHead: highlightHead,
      firstRow: firstRow,
      lastRow: lastRow,
      dark: dark,
      columnSortIndex: columnSortIndex,
      sortState: sortState,
      sortable: type === table_types.CellTypes.SUPER_HEADER ? false : sortable,
      highlightSortedColumn: highlightSortedColumn,
      highlightColor: highlightColor
    };

    if (highlightedCells) {
      for (var c = 0; c < highlightedCells.length; c++) {
        if (highlightedCells[c].dataField === dataField && highlightedCells[c].rowIndex === rowIndex) {
          cellProps.cellHighlighted = true;
        }
      }
    } // Discover the start of the first column group for cell border generating purposes


    if (!foundFirstGroupStart && colgroupStart) {
      cellProps.firstGroupStart = true;
      foundFirstGroupStart = true;
    } // Create a key for each table cell in the row


    var key = "".concat(type, "-").concat(rowIndex, "-").concat(i); // Find if a custom cell element exists

    var clonedElement = null;

    if (customCells) {
      customCells.forEach(function (custom) {
        if (type === custom.cellType && dataField === custom.dataField) {
          clonedElement = /*#__PURE__*/React__default.cloneElement(custom.customCell, _objectSpread(_objectSpread({}, props), cellProps));
        }
      });
    } // Build the appropriate table cell element


    var tableCell$1 = clonedElement ? /*#__PURE__*/React__default.createElement(tableCell, _extends({}, cellProps, {
      key: key,
      content: clonedElement
    })) : /*#__PURE__*/React__default.createElement(tableCell, _extends({}, cellProps, {
      key: key
    }));
    columns.push(tableCell$1);
  });
  return columns;
};

var getColumns = function getColumns(props) {
  var type = props.type,
      columnData = props.columnData;
  var rowColumns = [];
  columnData.forEach(function (column, i) {
    var columnAsGroup = column; // If we're dealing with a group of columns

    if (columnAsGroup.hasOwnProperty('groupColumns')) {
      // Retrieve the passed columns
      var columns = columnAsGroup.groupColumns; // If we're looking at super headers,
      // create the special group spans

      if (type === table_types.CellTypes.SUPER_HEADER) {
        var rowCol = {
          content: columnAsGroup.groupTitle,
          colgroupSpan: columnAsGroup.groupColumns.length
        };
        rowColumns.push(rowCol); // If we're dealing with run-of-the-mill columns
        // Set appropriate colgroup starts and ends
        // and signify that it belongs to a superheader group
      } else {
        var hasSuperHeader = !!columnAsGroup.groupTitle;
        columns[columns.length - 1].colgroupEnd = true;
        columns[0].colgroupStart = true;
        var columns2 = columns.map(function (entry) {
          entry.hasSuperHeader = hasSuperHeader;
          return entry;
        });
        rowColumns = rowColumns.concat(columns2);
      }
    } else {
      var columnAsSingle = column; // if the type isn't super header, pass it along
      // else, pass a blank placeholder super-header row

      if (type !== table_types.CellTypes.SUPER_HEADER) {
        rowColumns.push(columnAsSingle);
      } else {
        rowColumns.push({
          content: /*#__PURE__*/React__default.createElement("br", null),
          colgroupSpan: 1,
          pinned: columnAsSingle.pinned
        });
      }
    }
  });
  return getCells(rowColumns, props);
};

var TableRow = function TableRow(props) {
  var rowIndex = props.rowIndex,
      tableRowHandlers = props.tableRowHandlers,
      selectedRowIndex = props.selectedRowIndex; // Build the row

  var tableRow = getColumns(props);
  var selected = selectedRowIndex === rowIndex;
  return /*#__PURE__*/React__default.createElement("tr", _extends({
    key: "row-".concat(rowIndex)
  }, tableRowHandlers, {
    "data-selected": selected
  }), tableRow);
};

module.exports = TableRow;
